import { deleteOferta, getOfertasPanel } from "../../services/OfertasCabServices";
import { OfertasCabContext } from "./OfertasCabContext"

export const OfertasCabState = ({ children }) => {
    const getOfertasPanelData = async (searchTerm,numPagina, filas) => {
        let res = await getOfertasPanel(searchTerm,numPagina, filas);
        return res
    }

    const deleteOfertaData = async (body) => {
        const res = await deleteOferta(body)
        return res
    }
   
    return <OfertasCabContext.Provider value={{
        deleteOfertaData,
        getOfertasPanelData,
    }} >
        {children}
    </OfertasCabContext.Provider>
}